module.exports = __webpack_public_path__ + "static/media/smiu_logo.50ec1094.png";